import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { EstadosComandaHistorial } from "src/gql/schema"
import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import { HeaderProps } from "../../hooks/useHeaderProps"

const useEstatusOrdenHeader = <T extends string>({
    headerValue,
    valueToDisplay,
}: HeaderProps<T>): FlexibleTableHeaderColumn => {
    const options = Object.values(EstadosComandaHistorial).map((estado) => ({
        value: estado,
        valueToDisplay: formatTextWithCapitalize(estado),
    }))

    return {
        value: headerValue,
        valueToDisplay,
        filterMenu: options,
        isFilterUnique: false,
        filterSuggetions: false,
    }
}

export default useEstatusOrdenHeader
